import ModalComp, { SETTINGS_MODAL, MODIFY_MODAL, SUCCESS_MODAL } from './Modal';

export { SETTINGS_MODAL, MODIFY_MODAL, SUCCESS_MODAL };
export default ModalComp;


// WEBPACK FOOTER //
// ./src/components/Modal/index.js